import { retrieveDeepSearchList } from '@/api/ai'
import { useTextSearch } from '@/hooks/useTextSearch'
import { useLanguageStore } from '@/pinia/language'

const list = shallowRef([])

export const useDeepSearch = () => {
  const route = useRoute()
  const { getTextSearchHistory } = useTextSearch()
  const language = useLanguageStore()

  /**
   * 请求状态
   * 0 -> Keyword analysising ...
   * 1 -> Organizing related items ...
   * 2 -> Generating, please wait ...
   * 3 -> Search Successfully
   */
  const status = ref(0)
  const loading = ref(false)

  const userAddress = computed(() => {
    const addressStr = localStorage.getItem('addressForm')
    if (addressStr == null) return null
    const address = JSON.parse(addressStr)
    return `${address.country} ${address.province} ${address.city} ${address.streetAddress} ${address.aptEtc}`
  })

  /**
   * 防止出现旧的搜索结果被继续使用的情况
   */
  let unmounted = false

  onBeforeMount(async () => {
    try {
      loading.value = true
      updateRequestStatus()
      const data = await retrieveDeepSearchList({
        search_language: language.current,
        search_query: route.query.keyword,
        category_id: route.query.categoryId,
        category_name: route.query.categoryName,
        user_address: userAddress.value,
        search_query_history: getTextSearchHistory(),
        page_size: 50
      })
      if (unmounted) return
      list.value = data.search_words
      status.value = 3
    } finally {
      loading.value = false
    }
  })

  onBeforeUnmount(() => {
    list.value = []
    unmounted = true
  })

  const updateRequestStatus = (timer = 2) => {
    setTimeout(() => {
      if (status.value < 2) {
        status.value += 1
        updateRequestStatus(timer + 1)
      }
    }, timer * 1000)
  }

  return { loading, list, status }
}

/**
 * 给到外层直接获取 DeepSearch 结果值
 * @returns { list }
 */
export const useDeepSearchList = () => {
  return { list }
}
